import { HTTPService as Srv } from '@services';

export const $pdf_get = async (
	{ onStatus = null, onOK = null, onFail = null, ...handler }, // => Handler
	{ file = '' || null, ...body }, // => body
) =>
	await Srv.handler({
		service: async () =>
			await Srv.POST('pdf/get', {
				file,
				...body,
			}),
		onOK,
		onFail,
		onStatus,
		...handler,
	});
